export const getProperty = (item, string) => {
  if (item === undefined || item === null) return ''

  const parts = string.split('.')

  let current = item

  for (const part of parts) {
    if (current === undefined || current === null) return ''

    // Check if part contains array indices, e.g., roles[0].description
    const arrayMatch = part.match(/^([a-zA-Z_$][0-9a-zA-Z_$]*)(\[(\d+)\])?$/)

    if (arrayMatch) {
      const propName = arrayMatch[1]
      const arrayIndex = arrayMatch[3] !== undefined ? parseInt(arrayMatch[3], 10) : undefined

      if (arrayIndex !== undefined) {
        if (Array.isArray(current[propName])) {
          current = current[propName][arrayIndex]
        } else {
          return '' // Not an array, return empty string
        }
      } else {
        current = current[propName]
      }
    } else {
      current = current[part]
    }
  }

  return current !== undefined ? current : ''
}

export const getSubProperty = (item, arrayString) => {
  let result = item
  arrayString.forEach((string) => {
    if (!result || !result[string]) {
      result = ''
      return
    }
    result = result[string]
  })
  return result
}

export const getLocation = () => {
  return new Promise((resolve, reject) => {
    const successCallback = (position) => {
      const location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      }
      resolve(location)
    }

    const errorCallback = (error) => {
      const { code } = error

      switch (code) {
        case error.TIMEOUT:
          resolve(null)
          break

        case error.PERMISSION_DENIED:
          console.error('Foi negado acesso às informações de localização do usuário!')
          resolve(null)
          break

        case error.POSITION_UNAVAILABLE:
          console.error('As informações de localização do usuário são inválidas!', '', 'error')
          resolve(null)
          break

        default:
          resolve(null)
      }
    }

    if (window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        successCallback,
        errorCallback,
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 600000 })
    } else {
      window.Toast.fire('Geolocalização não é suportada por este navegador.')
      resolve(null)
    }
  })
}

export const clone = (obj) => JSON.parse(JSON.stringify(obj))

export default {
  getLocation,
  getProperty,
  clone,
}
